export const formatCurrency = (amount?: number | null | string): string => {
  if (amount === null) return "N/A";
  const value = parseFloat(amount as string);
  const isWhole = value % 1 === 0;

  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: isWhole ? 0 : 2,
    maximumFractionDigits: isWhole ? 0 : 2,
  }).format(value);
};

export enum BILLING_CLASS {
  FACILITY = "FACILITY",
  PROFESSIONAL = "PROFESSIONAL",
}

export enum RATE_TYPE {
  FACILITY = "FACILITY",
  PROFESSIONAL = "PROFESSIONAL",
  TOTAL = "TOTAL",
}

export enum RATE_SUB_TYPE {
  NEGOTIATED = "NEGOTIATED",
  CALCULATED = "CALCULATED",
}

export enum BENEFIT_TYPE {
  COPAY = "COPAY",
  COINSURANCE = "COINSURANCE",
}

export const EXCLUDED_POS = ["PHARMACY", "OTHERS"];

export const matchPosItemType = [
  { name: "PHARMACY", code: "1" },
  { name: "TELEMEDICINE", code: "2" },
  { name: "OUTPATIENT", code: "3" },
  { name: "OFFICE", code: "4" },
  { name: "IN_PATIENT", code: "5" },
  { name: "EMERGENCY_ROOM", code: "6" },
  { name: "OTHERS", code: "7" },
];

export const posTypeMap = new Map<string, string>(
  matchPosItemType.map((item) => [item.name, item.code]),
);
